import styled from 'styled-components'
export const Inputs = styled.input`
  font-size: 16px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #515151 !important;
  background: transparent;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2c65ac !important;
  }
`
